import { render, staticRenderFns } from "./GtAvatar.vue?vue&type=template&id=5a7bb532&"
import script from "./GtAvatar.vue?vue&type=script&lang=ts&"
export * from "./GtAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./GtAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports